import { t } from 'i18next';

/** Return a number formatted as a number of ETP.
 * @param value - The number to format
 * @returns A string to represent the number has a number of ETP.
 */
export const formatETP = (value: number): string => {
    const strVal = value.toLocaleString(navigator.language, {
        maximumFractionDigits: 2,
    });
    const etpStr = t('humanResources.etp');
    return `${strVal} ${etpStr}`;
};

/** Return a number formatted as a number of hours.
 * @param value - The number to format
 * @returns A string to represent the number as a number of hours.
 */
export const formatHours = (value: number): string => {
    const strVal = value.toLocaleString(navigator.language, {
        maximumFractionDigits: 2,
    });
    const hoursStr = t('humanResources.payState.fmt.hour', { count: 2 });
    return `${strVal} ${hoursStr}`;
};
